.slider {
  padding: var(--space-3) 12px;
}

.track {
  position: relative;
  height: 4px;
  border-radius: 999px;
  background: var(--bg-inset);
}

.range {
  position: absolute;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: var(--text-muted);
}

.handle {
  position: absolute;
  top: 50%;
  width: 18px;
  height: 18px;
  margin-left: -9px;
  transform: translateY(-50%);
  border-radius: 50%;
  border: 2px solid var(--border-strong);
  background: var(--bg-elevated);
  box-shadow: var(--shadow-md);
  cursor: grab;
  padding: 0;
  transition: border-color var(--duration-fast) var(--ease-default);
}

.handle::before {
  /* The pause-bars glyph from the OG handle. */
  content: '';
  position: absolute;
  inset: 0;
  margin: auto;
  width: 5px;
  height: 7px;
  border-left: 1.5px solid var(--text-muted);
  border-right: 1.5px solid var(--text-muted);
}

.handle:hover,
.handle:focus-visible {
  border-color: var(--accent-secondary);
  outline: none;
  cursor: grab;
}

.handle:active {
  cursor: grabbing;
}
